import {hasNamesAndNumbers, hasUpload} from '~/selectors/CanvasSelectors';
import {
  getNameCount,
  getNamesAndNumbersSizes,
  getNumberCount
} from '~/selectors/NamesAndNumbersSelectors';
import {
  anchorColorCount,
  getDefaultQuantities,
  getRealTimePriceQuote
} from '~/selectors/ProductSelectors';
import {getPostalCode, getQuantitiesJs} from '~/selectors/QuoteSelectors';
import {getInkMatchCount} from '~/selectors/DesignSelectors';
import {getCombinedSleeveColorCounts} from '~/utils/quote';
import {getZipCodeCookie} from '~/utils/user';

const defaultConfig = {
  allowBlankQuote: false,
  isVolumeDiscountFlag: false,
  useDefaultQuantity: false,
  useTotalQuantity: false,
  useZipCodeGuess: false,
  overrideZipCode: false
};

export function serialize(state, config = {}) {
  const {
    isVolumeDiscountFlag,
    useDefaultQuantity,
    useTotalQuantity,
    useZipCodeGuess,
    overrideZipCode,
    zipCodeParam,
    customItems
  } = {
    ...defaultConfig,
    ...config
  };
  let items = null;

  if (customItems) {
    items = customItems;
  } else {
    const quantities = useDefaultQuantity
      ? getDefaultQuantities(state)
      : useTotalQuantity
        ? getRealTimePriceQuote(state)
        : getQuantitiesJs(state);

    const namesAndNumbers = hasNamesAndNumbers(state)
      ? getNamesAndNumbersSizes(state)
      : {};

    items = Object.keys(quantities).map(productId => {
      return {
        product_id: productId,
        sizes: {...quantities[productId], ...namesAndNumbers},
        name_count: getNameCount(state),
        number_count: getNumberCount(state)
      };
    });
  }

  const zipCodeGuess = useZipCodeGuess && getZipCodeCookie();

  let zipCode = getPostalCode(state) || zipCodeGuess;

  if (overrideZipCode) {
    zipCode = zipCodeParam;
  }

  const colorCounts = config.colorCounts || anchorColorCount(state);
  const combinedColorCounts = getCombinedSleeveColorCounts({colorCounts});
  const ink_match_count = getInkMatchCount(state);

  let params = {
    color_counts: combinedColorCounts,
    items,
    ink_match_count,
    postal_code: zipCode,
    sponsorship: false,
    upload: hasUpload(state)
  };

  if (isVolumeDiscountFlag) {
    let {color_counts, items} = params;
    color_counts = JSON.stringify(color_counts);
    items = JSON.stringify(items);

    params = {...params, color_counts, items};
    return JSON.stringify({quote: params});
  }

  return JSON.stringify({quote_info: params});
}
